import React, { useEffect, useState } from 'react'
import { Avatar, Card, Col, Row, Radio, Tooltip, Spin } from 'antd'
import './style.css'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaCalendarAlt, FaCheck, FaChevronLeft, FaUser } from 'react-icons/fa';
import { BsCalendarCheckFill } from "react-icons/bs";
import useWindowSize from '../../../../../config/hooks/utility/useWindowSize';
import { FaStar } from "react-icons/fa";
import { FaStarHalf } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import Button from '../../../../../components/FormElements/Button';
import { CiGlobe } from 'react-icons/ci';
import { FaCircleCheck } from 'react-icons/fa6';
import { LuMapPin } from 'react-icons/lu';
import { getAllServices, getBookingStatus, getCurrentLocation, getEllipsedString, getFormattedDateTime, getInitials, getLastLayerServices, getServicesList, getValidUrl } from '../../../../../config/utils';
import Modal from '../../../../../components/Modal';
import successCheck from '../../../../../assets/images/check.png'
import { useDispatch, useSelector } from 'react-redux';
import useBookingApi from '../../../../../config/hooks/api/booking/useBookingApi';
import { setAppLoading, setError, setMessage } from '../../../../../store/common/generalSlice';
import BookingForm from '../../../../../components/BookingForm';
import CarRegistrationNumberPlate from '../../../../../components/Elements/CarRegistrationNumberPlate';
import { MdMyLocation } from 'react-icons/md';
import useQuoteApi from '../../../../../config/hooks/api/booking/quote/useQuoteApi';
import Prompt from '../../../../../components/Prompt';
import { filtersDataFormatter } from '../../../../../config/utils/FiltersDataFormatter';
import { filtersSelectedDataFormatter } from '../../../../../config/utils/FiltersSelectedDataFormatter';
import { extractKeysAndValues, extractValues } from '../../../../../config/utils/ExtractValues';
import { getMatchingIds } from '../../../../../config/utils/GetMatchingIds';
import { bookingDecisions, bookingStatusDetails } from '../../../../../config/utils/constants';
import useJobApi from '../../../../../config/hooks/api/booking/job/useJobApi';
import LocationPicker from '../../../../../components/LocationPicker';
import ReviewInput from '../../../Review/ReviewInput';
import { LoadingOutlined } from '@ant-design/icons';
import { cardImageSelector } from '../../../../../config/utils/CardImageSelector';
import DisputeForm from '../../../../../components/DisputeForm';
import ChatModal from '../../../Chats/ChatModal';
import { adminActionIdentifier } from '../../../../../config/utils/StatusIdentifier';
import { useMutation } from 'react-query';
import axiosInstance from '../../../../../config/api';
import { fetchCards } from '../../../../../store/common/paymentSlice';


const BookingDetails = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { bookingId } = useParams()
    const { width } = useWindowSize();

    const {
        createBooking,
        getUserBookingDetails,
        acceptRejectJobAmendOffer,
        rateBooking,
        getJobAmendDetails,
    } = useBookingApi()
    const { acceptRejectQuote, getQuoteDetails } = useQuoteApi()
    const { completeJobRequest } = useJobApi()

    const [bookingDetails, setBookingDetails] = useState(null)
    const [OtherUserBookingDetails, setOtherUserBookingDetails] = useState(null)
    const [bookingConfirm, setBookingConfirm] = useState(false)
    console.log(bookingConfirm, "=====", bookingDetails, "bookingConfirm")
    const [currentLocation, setCurrentLocation] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState(null)
    const [showActions, setShowActions] = useState(false)
    const [prompt, setPrompt] = useState(false)
    const [promptData, setPromptData] = useState({
        type: '',
        msg: ''
    })
    // const [amendJobModal, setAmendJobModal] = useState(false)
    const [userLocation, setUserLocation] = useState(null)
    const [refresh, setRefresh] = useState(0)
    const [showBookingForm, setShowBookingForm] = useState(false)
    const [rebookData, setRebookData] = useState(null)
    const [formattedData, setFormattedData] = useState(null)
    const [showLocationPicker, setShowLocationPicker] = useState(false)
    const [disputeModal, setDisputeModal] = useState(false);
    const [disputedAgainstId, setDisputedAgainstId] = useState(null);
    const [isAmendment, setIsAmendment] = useState(false); // a case to check amend
    const [amendmentData, setAmendmentData] = useState(null);
    const [spServices, setSpServices] = useState([])
    const [selectedQuoteForAccept, setSelectedQuoteForAccept] = useState(null)
    console.log(bookingDetails)

    const { loggedInUser } = useSelector(state => state?.auth);
    const getBookingDetails = async (bookingId) => {
        try {
            dispatch(setAppLoading(true))

            const response = await getUserBookingDetails(bookingId)
            if (response) {
                setBookingDetails(response?.data?.bookingDetails)
                dispatch(setAppLoading(false))
                if (response?.data?.bookingDetails?.serviceProvider?.services?.length > 0) {
                    setSpServices(() => {
                        return response?.data?.bookingDetails?.serviceProvider?.services?.filter(service => service?.parentId == null)
                    })
                }
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }
    const [quoteConfirm, setQuoteConfirm] = useState(false)
    const [showSPQuoteSuccessAlert, setShowSPQuoteSuccessAlert] = useState(false)

    const quoteDecisions = [
        {
            id: 1,
            label: "Accept",
            color: "#02B563",
        },
        {
            id: 2,
            label: "Reject",
            color: "#FF1D6A",
        },
    ]
    //accept/reject direct quote received from sp on su direct booking
    const handleReceivedQuoteForDirectBooking = async (decisionId) => {
        // console.log("Bilalalalalala", decisionId);
        // return
        if (decisionId == 1) {
            dispatch(setAppLoading(true))
            setOtherUserBookingDetails(null)
            setBookingConfirm(true)

            const { address } = await getCurrentLocation()
            setCurrentLocation(address)

            setTimeout(() => {
                dispatch(setAppLoading(false))
            }, 2000);
        }
        else {
            //rejection prompt
            handlePromptOpr('rejection', 'Are you sure you want to reject this direct booking offer?')
        }
    }

    const acceptRejectDirectQuote = async (decision, cardNumber) => {
        let quoteData = {};
        if (decision == 'Accept') {
            quoteData = {
                paymentMethodId: cardNumber
            }
        }
        try {
            const { lat: latitude, lng: longitude, address } = userLocation
            const response = await acceptRejectQuote(
                {
                    ...quoteData,
                    action: decision,
                    bookingId: bookingId,
                    quoteId: filteredQuotes[0]?.id,
                    latitude,
                    longitude,
                    address
                }
            )
            if (response) {
                setRefresh(prev => ++prev)
                return true
            }

            return false
        } catch (error) {
            console.log(error)
        }
    }

    // not for amend case
    const handlePaymentConfirm = async (status, cardNumber) => {
        try {
            dispatch(setAppLoading(true))
            const response = await acceptRejectDirectQuote('Accept', cardNumber)
            if (response) {
                setBookingConfirm(false)

                dispatch(setMessage(response?.data?.message))
                dispatch(setAppLoading(false))

                setShowModal(true)
                setModalType('bookingSuccess')
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const handleCloseJobPrompt = () => {
        handlePromptOpr('closeJob', 'Are you sure you want to close this job?')
    }

    const handleLocationPrompt = () => {
        handlePromptOpr('locationInfo', 'Location can only be seen on mobile app')
    }

    const bookingFormDataOrStatusHandler = async (data) => {
        const { selectedCategories } = bookingDetails;
        try {
            dispatch(setAppLoading(true))
            const temp = structuredClone(data);
            let finalSelectedValues;
            const payload = {
                ...temp?.fetchedVehicleData,
                ...temp?.location,
                serviceProviderId: bookingDetails?.serviceProviderId,
                quote: false,
                ...temp
            }

            if (selectedCategories) {
                // handling a specific case here to get an array of ids of first Layer
                // second Layer and third Layer based on the third layer values only.
                finalSelectedValues = getMatchingIds(selectedCategories, data?.services);
            }


            payload.vehicleRegistrationNo = data?.fetchedVehicleData?.vehicleRegistrationNumber
            // payload.services = [].concat(...Object.values(temp?.services))
            payload.services = finalSelectedValues //dev env
            // payload.services = [77,80,83] //QA env
            payload.year = payload.year + ''

            const keysToDelete = [
                'vehicleRegistrationNumber',
                'id',
                'createdAt',
                'carRegNo',
                'isApproved',
                'status',
                'updatedAt',
                'forgot',
                'fetchedVehicleData',
                'location',
                'userId'
            ]
            for (let i = 0; i < keysToDelete.length; i++) {
                delete payload[keysToDelete[i]]
            }

            const response = await createBooking(payload)
            if (response) {
                dispatch(setAppLoading(false))

                dispatch(setMessage(response?.data?.message))
                navigate('/booking/my-bookings')
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const handleBack = () => {
        if (showBookingForm) setShowBookingForm(false)
        else navigate('/')
    }

    const acceptRejectAmendment = async (decision, cardNumber) => {
        //2 => reject
        //3 => accept
        if (decision == 'accept') {
            try {
                dispatch(setAppLoading(true))
                const response = await acceptRejectJobAmendOffer(
                    bookingDetails?.bookingAmendment?.id,
                    { status: 3, paymentMethodId: cardNumber }
                )
                if (response) {
                    setRefresh(prev => ++prev)
                    setBookingConfirm(false)
                    dispatch(setAppLoading(false))
                    setShowModal(true)
                    setModalType('bookingSuccess')
                }
            }
            catch (error) {
                return
            }
        }
        else {
            try {
                dispatch(setAppLoading(true))
                const response = await acceptRejectJobAmendOffer(
                    bookingDetails?.bookingAmendment?.id,
                    { status: 2 }
                )
                if (response) {
                    setBookingConfirm(false)
                    setIsAmendment(false)
                    return response
                }
            }
            catch (error) {
                return
            }
        }
    }

    const handleAmendOffer = async (decisionId) => {
        if (decisionId == 1) {
            dispatch(setAppLoading(true))
            try {
                let res = await getJobAmendDetails(bookingId);
                if (res?.status == 200) {
                    setBookingConfirm(true)
                    // a add on state to make sure the amend case is true as on 'bookingConfirm' state is used
                    // on other places as well so a combination of bookingConfirm and isAmendment will show the 
                    // content for amendment.
                    setIsAmendment(true)
                    setAmendmentData(res?.data?.bookingDetails)
                    dispatch(setAppLoading(false))
                }
            } catch (error) {
                dispatch(setAppLoading(false))
                setBookingConfirm(false)
                setIsAmendment(false)
            }

            // setTimeout(() => {
            //     dispatch(setAppLoading(false))
            // }, 2000);
        }
        else {
            //rejection prompt
            handlePromptOpr('amendmentRejection', 'Are you sure you want to reject this Amendment?')
        }
    }


    const handlePromptResponse = async (resp) => {
        try {
            if (resp) {
                dispatch(setAppLoading(true))

                let response;
                if (promptData?.type == 'rejection') {
                    response = await acceptRejectDirectQuote('Reject')
                }
                else if (promptData?.type == 'closeJob') {
                    response = await completeJobRequest(bookingDetails?.id)
                }
                else if (promptData?.type == 'amendmentRejection') {
                    response = await acceptRejectAmendment('Reject')
                }
                // direct booking delete case commented for now 
                // else if (promptData?.type == 'deleteBooking') {
                //     response = await pendingBookingDelete();
                //     if (response) {
                //         dispatch(setMessage(response?.data?.message))
                //         setPrompt(false)
                //         setTimeout(() => {
                //             dispatch(setAppLoading(false))
                //             navigate('/bookings/my-bookings')
                //         }, [1000])
                //         return
                //     }
                // }

                else {
                    // response = await acceptRejectDirectQuote('Reject')
                }


                if (response) {
                    setPrompt(false)
                    dispatch(setAppLoading(false))
                    setRefresh(prev => ++prev)
                }
            }
            else {
                setPrompt(false)
                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleRebooking = () => {
        setShowBookingForm(true)
        const { address, latitude, longitude, postalCode, details, services, selectedCategories } = bookingDetails

        const initialData = filtersDataFormatter(selectedCategories);
        let selectedData;
        let selectedValues;
        if (initialData) {
            selectedData = filtersSelectedDataFormatter(initialData);
            // extract values func is used to get only the array of selected values from our 
            // modal's selected values object format.
            selectedValues = extractValues(selectedData);
        }
        setFormattedData({
            initialData,
            selectedData
        });
        setRebookData({
            carRegNo: bookingDetails?.vehicleRegistrationNo,
            location: { address, latitude, longitude, postalCode },
            // passing selected Values which is only an array of third layer values to get
            // the correct count initially and on deselect or select of any values from modal.
            services: selectedValues,
            details
        })
    }

    const handlePromptOpr = (type, msg) => {
        setPrompt(true)
        setPromptData({ type, msg })
    }

    const handleSelectedLocation = (selectedCoordinatesPreview, selectedLocationPreview) => {
        if (selectedLocationPreview && selectedCoordinatesPreview) {
            const { lat, lng } = selectedCoordinatesPreview
            setUserLocation({ address: selectedLocationPreview, lat, lng })
            setShowLocationPicker(false)
        }
    }

    const handleUserReview = async (data) => {
        try {
            if (!data) throw new Error('Required review and rating')

            dispatch(setAppLoading(true))

            const response = await rateBooking(bookingDetails?.id, data)
            if (response) {
                dispatch(setAppLoading(false))
                setShowModal(false)
                setModalType('')

                dispatch(setMessage(response?.data?.message))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const showReviewInput = () => {
        setShowModal(true)
        setModalType('rateBooking')
    }


    // useEffect callbacks may only return undefined or a cleanup function. An async
    // callback returns a Promise instead, which React later tries to call as its
    // cleanup on unmount, causing "TypeError: destroy is not a function". Wrapping
    // the async work in an inner IIFE keeps the effect callback itself synchronous.
    useEffect(() => {
        (async () => {
            const userLocation = await getCurrentLocation()
            setUserLocation(userLocation)
        })()
    }, [])

    useEffect(() => {
        if (bookingId) getBookingDetails(bookingId)
    }, [bookingId, refresh])

    useEffect(() => {
        if (bookingDetails) {
            if (getBookingStatus(bookingDetails?.status) == 'pending') {
                setShowActions(true)
            }
        }
    }, [bookingDetails])

    const handleDisputePrompt = () => {
        setDisputedAgainstId(loggedInUser?.id == bookingDetails?.userId ? bookingDetails?.serviceProviderId : bookingDetails?.userId);
        setDisputeModal(true)
    }

    // after getting success on dispute calling for an updated data.
    const disputeFormHandler = (msg) => {
        if (msg == 'success') {
            setRefresh(prev => ++prev)
        }
    }


    // delete direct booking cases commented for now
    // const deleteBookingHandler = () => {
    //     if (bookingId) handlePromptOpr('deleteBooking', 'Are you sure you want to delete this Booking?')
    // }

    // const pendingBookingDelete = async () => {
    //     try {
    //         dispatch(setAppLoading(true))
    //         let res = await deleteBooking(bookingId);
    //         if (res?.status == 200) {
    //             return res
    //         }
    //     } catch (error) {
    //         console.log(error)
    //         return
    //     }
    // }

    const quoteStatus = bookingStatusDetails

    // Handle quote accept button click - show payment selection
    const handleQuoteAcceptClick = (quote) => {
        setSelectedQuoteForAccept(quote)
        setOtherUserBookingDetails(quote)
        setBookingConfirm(true)
    }

    // Handle quote payment confirmation - call API with payment method
    const handleQuotePaymentConfirm = async (status, cardNumber) => {
        try {
            if (!selectedQuoteForAccept) return

            dispatch(setAppLoading(true))
            const response = await handleDecision(selectedQuoteForAccept.id, 'Accept', cardNumber)

            if (response) {
                setBookingConfirm(false)
                setSelectedQuoteForAccept(null)
                dispatch(setMessage(response?.data?.message || 'Quote accepted successfully'))
                setShowModal(true)
                setModalType('bookingSuccess')
            }
        } catch (error) {
            console.error("Error accepting quote:", error)
            dispatch(setAppLoading(false))
        }
    }

    const handleDecision = async (quoteId, decision, paymentMethodId = null) => {
        try {
            dispatch(setAppLoading(true))

            const { lat: latitude, lng: longitude, address } = userLocation

            // Conditionally add paymentMethodId if decision is Accept
            const payload = {
                action: decision,
                bookingId: bookingId,
                quoteId: quoteId,
                latitude,
                longitude,
                address
            }

            if (decision === 'Accept' && paymentMethodId) {
                payload.paymentMethodId = paymentMethodId
            }

            const response = await acceptRejectQuote(payload)
            if (response) {
                const data = { ...(response?.data?.quoteDetails || response?.data?.quote) }
                if (Object.keys(data).length) {
                    const idx = quoteStatus?.findIndex((e) => e.label?.toLowerCase() == data?.status.toLowerCase())
                    if (idx > -1) {
                        data.status = idx
                    }
                }
                setOtherUserBookingDetails(data);
                // setBookingConfirm(true)
                const spServicesArr = response?.data?.quote?.user?.services || response?.data?.quoteDetails?.user?.services
                if (spServicesArr?.length > 0) {
                    setSpServices(() => {
                        return spServicesArr?.filter(service => service?.parentId == null)
                    })
                }
                // Refresh the component to get updated booking details
                setRefresh(prev => ++prev)
                return response
            }
        } catch (error) {
            // OPTIMIZATION: Improved error handling with proper error logging and user feedback
            console.error("Error fetching quote details:", error)
            dispatch(setError("Failed to load quote details"))
            throw error
        } finally {
            // OPTIMIZATION: Added finally block to ensure loading state is always reset
            dispatch(setAppLoading(false))
        }
    }

    const filteredQuotes =
        bookingDetails?.quotes?.map(quote => quote)?.filter(
            quote => quote?.serviceProviderId == bookingDetails?.serviceProviderId
        );

    console.log('filteredQuotes', filteredQuotes)



    return (
        <React.Fragment>
            <Row>
                <Col
                    md={24}
                    sm={24}
                    xs={24}
                    className={`${showBookingForm ? 'md:pl-20 md:pr-2' : 'md:px-20'} sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6`}
                >
                    <div className='flex justify-between items-center'>
                        <h5 className='heading-5 text-slate-600 font-semibold'>Details</h5>
                        <div onClick={handleBack} className='cursor-pointer flex items-center'>
                            <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                            <small className='ml-2 font-medium'>Back</small>
                        </div>
                    </div>
                </Col>
                <Col
                    lg={showBookingForm ? 17 : 24}
                    md={showBookingForm ? 24 : 24}
                    sm={showBookingForm ? 24 : 24}
                    xs={24}
                    className={`${showBookingForm ? 'md:pl-20 md:pr-2' : 'md:px-20'} sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6`}
                >
                    {bookingDetails && Object.keys(bookingDetails).length ? (
                        <Card
                            bordered={false}
                            className='mb-4 rounded-md'
                        >
                            <div className='flex sm:flex-row flex-col'>
                                <div className='flex justify-center'>
                                    <Avatar
                                        className='border-2 p-1 mb-2 border-primary rounded-full'
                                        src={bookingDetails?.serviceProvider?.imageThumbUrl}
                                        alt="avatar"
                                        size={width > 767 ? 100 : 120}
                                    >
                                        {getInitials(bookingDetails?.serviceProvider?.userDetail?.businessName)}
                                    </Avatar>
                                </div>
                                <div className='flex sm:flex-row flex-col sm:items-center sm:justify-between  sm:ml-2 w-full'>
                                    <div className='flex flex-col justify-center ml-1 w-full'>
                                        <div className='flex flex-col sm:flex-row sm:justify-between justify-center items-center'>
                                            <div className='flex mr-2'>
                                                <div className='sm:mr-2'>
                                                    <h3 className='heading-3 font-bold sm:mb-1 mb-2 sm:text-left text-center whitespace-nowrap'>
                                                        {
                                                            getEllipsedString(bookingDetails?.serviceProvider?.userDetail?.businessName, 15)
                                                        }
                                                    </h3>
                                                </div>

                                                {
                                                    bookingDetails?.serviceProvider?.badges &&
                                                        bookingDetails?.serviceProvider?.badges.length ? (
                                                        <div className='flex items-center sm:w-[50px]'>
                                                            {bookingDetails?.serviceProvider?.badges.map(badge => (
                                                                <img
                                                                    key={'badge' + badge?.id}
                                                                    src={badge?.imageUrl}
                                                                    alt={badge?.name}
                                                                    className='img-fluid mr-2 badge'
                                                                    onError={(e) => { e.target.style.display = 'none' }}
                                                                />
                                                            ))}
                                                        </div>
                                                    )
                                                        : ''}
                                            </div>

                                            {/* case: inprogress */}
                                            {getBookingStatus(bookingDetails?.status) == 'in-progress' && (
                                                <div className="sm:flex hidden items-center justify-center border rounded-md px-2 py-1 border-[#1677ff] sm:w-2/7 w-2/7 h-fit md:h-[25px]">
                                                    <span className='text-[#1677ff] text-xs'>In-Progress</span>
                                                </div>
                                            )}

                                            <React.Fragment>
                                                {/* <div className='sm:hidden flex sm:justify-start justify-center'>
                                                    {
                                                        bookingDetails?.services &&
                                                            bookingDetails?.services.length ?
                                                            bookingDetails?.services.slice(0, 3).map((service, sIdx) => (
                                                                <span key={'ser1' + sIdx}>
                                                                    <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                        {service?.name}

                                                                        {sIdx < bookingDetails?.services.slice(0, 3).length - 1 &&
                                                                            (<span className='mx-1'>|</span>)}
                                                                        {sIdx == 2 && bookingDetails?.services.length > 3 ?
                                                                            (<span className='mr-1'>...</span>) : ''}
                                                                    </p>
                                                                </span>
                                                            )) : (
                                                                <small className='text-xs mb-3'>Services not available</small>
                                                            )}
                                                </div> */}
                                                {getBookingStatus(bookingDetails?.status) != 'completed' ? (
                                                    <div className='sm:hidden flex mb-4 sm:justify-start justify-center'>
                                                        <small className='mr-3 text-[#00B517] font-semibold'>
                                                            {
                                                                `${bookingDetails?.serviceProvider?.noOfBookingCompleted ?? 0} Job(s) Completed`
                                                            }
                                                        </small>
                                                        <small className='text-[#FF1D6A] font-semibold'>
                                                            ({
                                                                bookingDetails?.serviceProvider?.userDetail?.distance &&
                                                                bookingDetails?.serviceProvider?.userDetail?.distance.toFixed(2) + ' Miles Away'
                                                            })
                                                        </small>
                                                    </div>
                                                ) : ''}
                                            </React.Fragment>

                                            {
                                                getBookingStatus(bookingDetails?.status) == 'completed' &&
                                                (
                                                    <div className='sm:mb-0 mb-2 sm:mr-2 flex sm:flex-row flex-col w-full sm:justify-end'>
                                                        <div className='mb-2'>
                                                            <CarRegistrationNumberPlate regNumber={bookingDetails?.vehicleRegistrationNo} />
                                                        </div>
                                                        {!showBookingForm && (
                                                            <div className='sm:ml-2'>
                                                                <Button.Basic
                                                                    onClick={handleRebooking}
                                                                    disabled={false}
                                                                    icon={null}
                                                                    loading={false}
                                                                    type="primary"
                                                                    size='small'
                                                                    text='Rebook'
                                                                    className='bg-black sm:w-fit w-full px-3 py-5 text-xs'
                                                                />
                                                            </div>
                                                        )}
                                                        {
                                                            bookingDetails?.dispute &&
                                                            <div className='flex items-center justify-end ml-3'>
                                                                <div className="w-fit border rounded-md px-2 py-1 border-[#1677ff] mb-2">
                                                                    <span className='text-[#1677ff] text-xs'>
                                                                        {adminActionIdentifier(bookingDetails?.dispute?.adminAction)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                )}
                                        </div>
                                        <React.Fragment>
                                            {/* <div className='sm:flex hidden sm:justify-start justify-center'> */}
                                            {/* previous work */}
                                            {/* {
                                                    bookingDetails?.services &&
                                                        bookingDetails?.services.length ?
                                                        bookingDetails?.services.slice(0, 3).map((service, sIdx) => (
                                                            <span key={'ser2' + sIdx}>
                                                                <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                    {service?.name}

                                                                    {sIdx < bookingDetails?.services.slice(0, 3).length - 1 &&
                                                                        (<span className='mx-1'>|</span>)}
                                                                    {sIdx == 2 && bookingDetails?.services.length > 3 ?
                                                                        (<span className='mr-1'>...</span>) : ''}
                                                                </p>
                                                            </span>
                                                        )) : (
                                                            <small className='text-xs mb-3'>Services not available</small>
                                                        )} */}
                                            {/* </div> */}

                                            {/* updated work */}
                                            {/* <div className='flex justify-start'>
                                                {
                                                    bookingDetails?.selectedCategories &&
                                                        bookingDetails?.selectedCategories?.length > 0 ? (
                                                        <React.Fragment>
                                                            {
                                                                bookingDetails?.selectedCategories[0].subServices?.length > 0 ?
                                                                    <span className='flex gap-1 items-center justify-start'>
                                                                        <p className='text-gray-500 font-semibold text-xs mb-3 w-fit'>
                                                                            {bookingDetails?.selectedCategories[0].name + ','}
                                                                        </p>
                                                                        <p className='text-gray-500 font-semibold text-xs mb-3 w-fit'>
                                                                            {bookingDetails?.selectedCategories[0].subServices[0]?.name + ' ...'}                                                                            </p>
                                                                    </span>
                                                                    :
                                                                    <p className='text-center w-full sm:w-fit'>-</p>

                                                            }
                                                            {bookingDetails?.selectedCategories?.length > 0 &&
                                                                bookingDetails?.selectedCategories[0]?.subServices?.length > 0 &&
                                                                bookingDetails?.selectedCategories[0]?.subServices[0]?.subServices?.length > 0
                                                                ? (
                                                                    <Tooltip title={getServicesList(bookingDetails?.selectedCategories[0]?.subServices[0]?.subServices, true)}>
                                                                        <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                    </Tooltip>
                                                                ) : ''}
                                                        </React.Fragment>
                                                    ) : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                                }
                                            </div> */}
                                            <div className='flex justify-start mt-2'>
                                                {
                                                    bookingDetails?.serviceProvider?.services &&
                                                        spServices?.length > 0 ? (
                                                        <React.Fragment>
                                                            {
                                                                spServices?.slice(0, 3)?.map((service) => {
                                                                    if (service?.name) {
                                                                        return (
                                                                            <span className='flex gap-1 items-center justify-start' key={service?.id}>
                                                                                <p className='text-gray-500 font-semibold text-xs mb-3 w-fit'>
                                                                                    {service?.name + ','}
                                                                                </p>
                                                                            </span>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            {spServices?.length > 3 && <span>...</span>}
                                                            {spServices?.length > 3 &&
                                                                (
                                                                    <Tooltip title={getServicesList(spServices, false)}>
                                                                        <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                    </Tooltip>
                                                                )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                                }
                                            </div>

                                            {getBookingStatus(bookingDetails?.status) != 'completed' ? (
                                                <div className='sm:flex hidden mb-4 sm:justify-start justify-center'>
                                                    <small className='mr-3 text-[#00B517] font-semibold'>
                                                        {
                                                            `${bookingDetails?.serviceProvider?.noOfBookingCompleted ?? 0} Job(s) Completed`
                                                        }
                                                    </small>
                                                    <small className='text-[#FF1D6A] font-semibold'>
                                                        ({
                                                            bookingDetails?.serviceProvider?.userDetail?.distance &&
                                                            bookingDetails?.serviceProvider?.userDetail?.distance.toFixed(2) + ' Miles Away'
                                                        })
                                                    </small>
                                                </div>
                                            ) : ''}
                                        </React.Fragment>

                                        <div className='flex sm:flex-row flex-col pl-0 flex-wrap'>
                                            {/* case: inprogress */}
                                            {getBookingStatus(bookingDetails?.status) == 'in-progress' && (
                                                <div className="flex sm:hidden items-center justify-center border rounded-md px-2 py-1 border-[#1677ff] h-[25px] mb-2">
                                                    <span className='text-[#1677ff] text-xs'>In-Progress</span>
                                                </div>
                                            )}



                                            {getBookingStatus(bookingDetails?.status) != 'completed' &&
                                                bookingDetails?.serviceProvider?.averageRating !== undefined ? (

                                                <React.Fragment>
                                                    <div className='ratings sm:mr-2 mr-0 mb-2 bg-slate-100 flex  rounded-md items-center justify-center p-2 '>
                                                        <span className='mr-2 font-bold'>
                                                            {Math.floor(bookingDetails?.serviceProvider?.averageRating)}/5
                                                        </span>
                                                        {/* rated stars count */}
                                                        {
                                                            Array(Math.floor(bookingDetails?.serviceProvider?.averageRating))
                                                                .fill(0).map((el, index) => (
                                                                    <FaStar key={'rating' + index} className='text-primary' />
                                                                ))
                                                        }
                                                        {
                                                            bookingDetails?.serviceProvider?.ratingCount - Math.floor(bookingDetails?.serviceProvider?.ratingCount) != 0 &&
                                                            (<FaStarHalf className='text-primary' />)
                                                        }

                                                        {/* unrated stars count */}
                                                        {
                                                            Array(5 - Math.floor(bookingDetails?.serviceProvider?.averageRating))
                                                                .fill(0).map((el, index) => (
                                                                    <FaStar key={'rating2' + index} className='text-gray-400' />
                                                                ))
                                                        }
                                                    </div>
                                                    {/* <div className='bg-[#FEEDBF] sm:mr-2 mr-0 mb-2 p-2 rounded-md'>
                                                        <Link to={`tel:${bookingDetails?.serviceProvider?.phoneNo}`} className='block h-full'>
                                                            <div className='flex justify-center items-center h-full'>
                                                                <FaPhoneAlt className='text-2xl text-white bg-primary p-[5px] rounded-full' />
                                                                <small className='text-xs ml-2'>Call</small>
                                                            </div>
                                                        </Link>
                                                    </div> */}
                                                    <div className='sm:mr-2 mr-0 mb-2 p-2 text-xs bg-[#feedbf] rounded-md'>
                                                        <ChatModal selectedChatMemberData={bookingDetails?.serviceProvider} />
                                                    </div>
                                                </React.Fragment>
                                            ) : ''
                                            }

                                            {/* pending case ================ */}
                                            {getBookingStatus(bookingDetails?.status) == 'pending' && (
                                                <div className='mb-2 flex items-center gap-3'>
                                                    <Button.Basic
                                                        onClick={() => navigate(`/profile/${bookingDetails?.serviceProvider?.id}`)}
                                                        disabled={false}
                                                        icon={null}
                                                        loading={false}
                                                        type="primary"
                                                        size='medium'
                                                        text='View Profile'
                                                        className='sm:w-fit w-full p-5 text-xs'
                                                    />

                                                    {/* <Button.Basic
                                                        onClick={deleteBookingHandler}
                                                        disabled={false}
                                                        icon={null}
                                                        loading={false}
                                                        type="primary"
                                                        size='medium'
                                                        text='Delete Booking'
                                                        className='sm:w-fit w-full p-5 text-xs bg-red-600'
                                                    /> */}
                                                </div>
                                            )}

                                            {/* case: inprogress */}
                                            {
                                                getBookingStatus(bookingDetails?.status) == 'in-progress' &&
                                                <div className='flex'>

                                                    <div className='mb-2'>
                                                        <Button.Basic
                                                            disabled={false}
                                                            icon={null}
                                                            loading={false}
                                                            type="primary"
                                                            size='small'
                                                            text='View Location'
                                                            className='sm:w-fit w-full px-3 py-5 text-xs'
                                                            onClick={handleLocationPrompt}
                                                        />
                                                    </div>

                                                    <div className='mb-2 ml-2'>
                                                        <Button.Basic
                                                            disabled={bookingDetails?.isDisputed}
                                                            icon={null}
                                                            loading={false}
                                                            type="primary"
                                                            size='small'
                                                            text='Raise a dispute'
                                                            className={`sm:w-fit w-full px-3 py-5 text-xs disabled-btn`}
                                                            onClick={handleDisputePrompt}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {/* case: completed */}
                                            {/* su rates booking */}
                                            {
                                                getBookingStatus(bookingDetails?.status) == 'completed' &&
                                                <div className='flex'>
                                                    <div
                                                        className='mb-2 flex bg-primary p-2 rounded-md text-white justify-center items-center
                                                    cursor-pointer'
                                                        onClick={showReviewInput}
                                                    >
                                                        <FaStar className={`text-xl w-[15px] mr-2`} />
                                                        <p>Rating</p>
                                                    </div>

                                                    {
                                                        bookingDetails?.paymentStatus == 'UNPAID' && !showBookingForm ?
                                                            <div className='mb-2 ml-2'>
                                                                <Button.Basic
                                                                    disabled={bookingDetails?.isDisputed}
                                                                    icon={null}
                                                                    loading={false}
                                                                    type="primary"
                                                                    size='small'
                                                                    text='Raise a dispute'
                                                                    className={`sm:w-fit w-full px-3 py-5 text-xs disabled-btn`}
                                                                    onClick={handleDisputePrompt}
                                                                />
                                                            </div>
                                                            : ''
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className='border-dashed border-1 border-gray-200 mb-3' />
                            <div>
                                <div className='flex sm:flex-row justify-between items-start flex-col mb-3 flex-wrap'>
                                    {bookingDetails?.address && (
                                        <div className='flex items-center sm:mb-0 mb-2 w-full sm:w-2/6'>
                                            <div className='w-[20px] mr-2'>
                                                <LuMapPin className='text-2xl text-white bg-primary p-[3px] rounded-full' />
                                            </div>
                                            <small className='text-xs font-md'>{bookingDetails?.address}</small>
                                        </div>
                                    )}
                                    {/* {bookingDetails?.serviceProvider?.phoneNo && (
                                        <div className='flex items-center sm:mb-0 mb-2 w-full sm:w-1/6 mr-4'>
                                            <Link to={`tel:${bookingDetails?.serviceProvider?.phoneNo}`} className='flex h-full items-center'>
                                                <div className='w-[20px] mr-2'>
                                                    <FaPhoneAlt className='text-2xl text-white p-[4px] rounded-full bg-[#3879f0]' />
                                                </div>
                                                <small className='text-xs font-md  text-wrap break-all'>{bookingDetails?.serviceProvider?.phoneNo}</small>
                                            </Link>
                                        </div>
                                    )} */}
                                    {bookingDetails?.serviceProvider?.userDetail?.website && (
                                        <div className='flex items-center sm:mb-0 mb-2 w-full sm:w-1/6'>
                                            <a
                                                href={getValidUrl(bookingDetails?.serviceProvider?.userDetail?.website)}
                                                target="_blank"
                                                className='flex h-full items-center'
                                            >
                                                <div className='w-[20px] mr-2'>
                                                    <CiGlobe className='text-2xl text-white p-[4px] rounded-full bg-[#00b517]' />
                                                </div>
                                                <small className='text-xs font-md text-wrap break-all'>{bookingDetails?.serviceProvider?.userDetail?.website}</small>
                                            </a>
                                        </div>
                                    )}
                                    {
                                        bookingDetails?.createdAt ?
                                            (
                                                <div className='flex items-center sm:mb-0 mb-2 w-full sm:w-1/6'>
                                                    <div className='w-[20px] mr-2'>
                                                        <FaCalendarAlt className='bg-[#fa3434] text-white rounded-full p-[5px] text-2xl' />
                                                    </div>
                                                    <small className='text-xs font-md'>
                                                        {getFormattedDateTime(`${bookingDetails?.createdAt}`, 'DD-MM-YYYY HH:mm')}
                                                    </small>
                                                </div>
                                            ) : ''}
                                    {/* in case of complete booking and isDisputed false, showing updatedAt date and time */}
                                    {
                                        bookingDetails?.status == 1 &&
                                            !bookingDetails?.isDisputed &&
                                            bookingDetails?.updatedAt ?
                                            (
                                                <div className='sm:pt-2 flex items-center w-full sm:w-1/6'>
                                                    <div className='w-[20px] mr-2'>
                                                        <BsCalendarCheckFill className='bg-[#000] text-white rounded-full p-[5px] text-2xl' />
                                                    </div>
                                                    <small className='text-xs font-md'>
                                                        {getFormattedDateTime(`${bookingDetails?.updatedAt}`, 'DD-MM-YYYY HH:mm')}
                                                    </small>
                                                </div>
                                            ) : ''}
                                </div>

                                <hr className='border-dashed border-1 border-gray-200 mb-4' />

                                <div className='mb-4'>
                                    <h6 className='heading-6 font-bold text-sm mb-4'>Services Requested:</h6>
                                    {/* previous work */}
                                    {/* <div className='flex sm:flex-row flex-col'>
                                        {
                                            bookingDetails?.services &&
                                                bookingDetails.services.length ? (
                                                <React.Fragment>
                                                    {bookingDetails.services.slice(0, 3).map((service, sIdx) => (
                                                        <div className='flex items-center sm:mr-2 mb-2' key={'ser3' + sIdx}>
                                                            <div className='w-[20px]'>
                                                                <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                                            </div>
                                                            <small className='font-md text-xs'>{service?.name}</small>
                                                        </div>
                                                    ))}
                                                    {bookingDetails?.services?.length > 3 ? (
                                                        <Tooltip title={getServicesList(bookingDetails?.services)}>
                                                            <p className='text-xs cursor-pointer'>show all</p>
                                                        </Tooltip>
                                                    ) : ''}
                                                </React.Fragment>
                                            )
                                                : (
                                                    <small className='text-xs'>Services not available</small>
                                                )
                                        }
                                    </div> */}

                                    {/* updated work */}
                                    {/* <div>
                                        {bookingDetails?.selectedCategories?.length > 0 ?
                                            getAllServices(bookingDetails?.selectedCategories)
                                            :
                                            <small className='text-xs'>Services not available</small>
                                        }
                                    </div> */}

                                    <div className='mt-4'>
                                        {bookingDetails?.services?.length > 0 ?
                                            getLastLayerServices(bookingDetails?.services)
                                            :
                                            <small className='text-xs'>Services not available</small>
                                        }
                                    </div>
                                </div>

                                {/* {
                                    (getBookingStatus(bookingDetails?.status) == 'completed' || getBookingStatus(bookingDetails?.status) == 'in-progress')
                                    && bookingDetails?.bookingType == 'QUOTE' &&
                                    <div className='mb-4'>
                                        <h6 className='heading-6 font-bold text-sm mb-4'>Services Accepted:</h6>
                                        <div className='flex sm:flex-row flex-col'>
                                            {
                                                bookingDetails?.quotes?.length > 0
                                                    ? (
                                                        <React.Fragment>
                                                            {
                                                                bookingDetails?.quotes?.map((quote) => {
                                                                    if (quote?.status == 'ACCEPTED') {
                                                                        return quote?.services?.length > 0 ? quote?.services.slice(0, 3).map((service, sIdx) => {
                                                                            return (<div className='flex items-center sm:mr-2 mb-2' key={'ser4' + sIdx}>
                                                                                <div className='w-[20px]'>
                                                                                    <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                                                                </div>
                                                                                <small className='font-md text-xs'>{service?.name}</small>
                                                                            </div>)
                                                                        })
                                                                            :
                                                                            'No services available'
                                                                    }
                                                                })
                                                            }
                                                            {bookingDetails?.quotes?.length > 0 ?
                                                                bookingDetails?.quotes?.map((quote, index) => {
                                                                    if (quote?.status == 'ACCEPTED') {
                                                                        return quote?.services?.length > 3 ? (
                                                                            <Tooltip key={'tooltip1' + index} title={getServicesList(quote?.services)}>
                                                                                <p className='text-xs cursor-pointer'>show all</p>
                                                                            </Tooltip>
                                                                        ) : ''
                                                                    }
                                                                })
                                                                : ''}
                                                        </React.Fragment>
                                                    )
                                                    : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                            }
                                        </div>
                                    </div>
                                } */}

                                <hr className='border-dashed border-1 border-gray-200 mb-4' />

                                {bookingDetails && bookingDetails?.details && (
                                    <div className='mb-4'>
                                        <h6 className='heading-6 font-bold text-sm mb-2'>Additional Info/Note</h6>
                                        <small className='text-xs font-md'>{bookingDetails?.details}</small>
                                    </div>
                                )}

                                {
                                    bookingDetails?.dispute &&
                                    <React.Fragment>
                                        <h6 className='heading-6 font-bold text-sm mb-2'>
                                            Dispute Reason
                                        </h6>
                                        <small className='text-xs font-md'>
                                            {bookingDetails?.dispute?.disputeDetail ? bookingDetails?.dispute?.disputeDetail : '-'}
                                        </small>
                                    </React.Fragment>
                                }

                                {bookingDetails?.bookingAmendment && <hr className='border-dashed border-1 border-gray-200 mb-4 mt-2' />}

                                {/* Amend info */}
                                {
                                    bookingDetails?.bookingAmendment && (
                                        <div className='flex flex-col gap-4'>
                                            <h6 className='text-[13px] text-[#7C8BA0]'>Additional service Charges: <span className='text-base font-bold text-black'>£{bookingDetails?.bookingAmendment?.price ? bookingDetails?.bookingAmendment?.price : 0}</span></h6>
                                            <hr className='border-dashed border-1 border-gray-200' />
                                            <div className='flex flex-col'>
                                                <h6 className='font-bold text-sm mb-2 text-[#42425B]'>Additional service changes:</h6>
                                                <p className='text-[#42425B] break-all text-xs font-medium'>{bookingDetails?.bookingAmendment?.note ? bookingDetails?.bookingAmendment?.note : '-'}</p>
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    !bookingConfirm && getBookingStatus(bookingDetails?.status) == 'responded' &&
                                        bookingDetails?.quotes.length ?
                                        (
                                            <div className='bg-blue-500 p-2 w-full mb-4 rounded-md'>
                                                <small className='text-white'>
                                                    {`${loggedInUser?.fullName} requesting for a service from ${bookingDetails?.serviceProvider?.userDetail?.businessName}, your vehicle car no. is ${bookingDetails?.vehicleRegistrationNo}. The quoted price is
                                                £${bookingDetails?.quotes[0]?.price} 
                                                ${bookingDetails?.quotes[0]?.vatIncluded ? '(Prices include VAT where applicable)' : ''}
                                                The booking date and time ${getFormattedDateTime(`${bookingDetails?.quotes[0]?.date}`, 'DD-MM-YYYY')} at ${bookingDetails?.quotes[0]?.time}.`}
                                                </small>
                                            </div>
                                        ) : ''}

                                {/* case: job amend by sp */}
                                {/* su accept/reject amend offer from sp */}
                                {
                                    !bookingConfirm && !isAmendment &&
                                        getBookingStatus(bookingDetails?.status) == 'in-progress' &&
                                        bookingDetails?.bookingAmendment &&
                                        getBookingStatus(bookingDetails?.bookingAmendment.status) == 'pending' ?
                                        (
                                            <div className='mb-4'>
                                                <div className='bg-blue-500 p-2 w-full mb-4 rounded-md'>
                                                    <small className='text-white'>
                                                        {`${bookingDetails?.serviceProvider?.userDetail?.businessName} has
                                                    sent you additional charges and notes on your booking No. 
                                                    ${bookingDetails?.bookingAmendment?.bookingId} quoted price 
                                                    £${bookingDetails?.bookingAmendment?.price} 
                                                    `}
                                                    </small>
                                                </div>
                                                <div className='flex'>
                                                    {bookingDecisions.map((decision, index) => (
                                                        <div
                                                            onClick={() => handleAmendOffer(decision?.id)}
                                                            className={`sm:w-fit w-full mr-2 text-xs px-6 py-3 text-white rounded-md cursor-pointer text-center`}
                                                            style={{ backgroundColor: decision?.color }}
                                                            key={'decision' + index}
                                                        >
                                                            {decision?.label}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                        : ''
                                }
                                {
                                    getBookingStatus(bookingDetails?.status) == 'in-progress' &&
                                        bookingConfirm && isAmendment ?
                                        <div className='bg-slate-100'>
                                            <AmendmentDetails
                                                data={bookingDetails}
                                                onSuccess={acceptRejectAmendment}
                                            />
                                        </div>
                                        :
                                        ''
                                }


                                {/* case: pending */}
                                {/* su accepts/rejects quote sent by sp */}
                                {
                                    !bookingConfirm && bookingDetails?.bookingType == 'DIRECT' &&
                                        (bookingDetails?.status == 0 || bookingDetails?.status == 3 || bookingDetails?.status == 5) && filteredQuotes?.length != 0 ?
                                        (
                                            <div className='flex mb-4'>
                                                {bookingDecisions.map((decision, index) => (
                                                    <div
                                                        onClick={() => handleReceivedQuoteForDirectBooking(decision?.id)}
                                                        className={`sm:w-fit w-full mr-2 text-xs px-6 py-3 text-white rounded-md cursor-pointer text-center`}
                                                        style={{ backgroundColor: decision?.color }}
                                                        key={'decision2' + index}
                                                    >
                                                        {decision?.label}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : ''}


                                {bookingDetails?.quotes && bookingDetails?.quotes.length && (bookingDetails?.status == 3 || bookingDetails?.status == 5) ? (
                                    <div className='mt-4'>
                                        <h6 className='heading-6 font-bold text-sm mb-4'>Admin Assigned SP</h6>
                                        {
                                            (
                                                <Col span={24} className=' md:pt-6 sm:pt-6 px-2 pt-6'>
                                                    {
                                                        bookingDetails?.quotes && bookingDetails?.quotes.length ?
                                                            bookingDetails?.quotes?.map(quote => quote)?.filter(
                                                                quote => quote?.serviceProviderId != bookingDetails?.serviceProviderId
                                                            )?.map(quote => {
                                                                let servicesLength = quote?.services?.length || 0;
                                                                return (
                                                                    <Card
                                                                        bordered={false}
                                                                        className='mb-4 rounded-md'
                                                                        key={quote?.id}
                                                                    >
                                                                        <div className='flex lg:flex-row flex-col justify-between'>
                                                                            <div className='flex sm:flex-row flex-col sm:items-start items-center sm:mb-1 mb-4'>
                                                                                <div className='flex sm:flex-row flex-col mb-4'>
                                                                                    <Avatar
                                                                                        className='border-2 p-1 mb-2 border-primary rounded-full'
                                                                                        src={quote?.user?.imageThumbUrl}
                                                                                        alt="avatar"
                                                                                        size={width > 767 ? 100 : 120}
                                                                                    >
                                                                                        {getInitials(quote?.user?.userDetail?.businessName)}
                                                                                    </Avatar>
                                                                                </div>
                                                                                <div className='flex flex-col sm:ml-4  w-full'>
                                                                                    <div className='sm:mb-4 mb-6 ml-1'>
                                                                                        <div className='flex justify-center sm:justify-start'>
                                                                                            <h3 className='text-center md:text-left heading-3 font-bold mb-1'>
                                                                                                {getEllipsedString(quote?.user?.userDetail?.businessName, 15)}
                                                                                            </h3>

                                                                                            {
                                                                                                quote?.user?.badges &&
                                                                                                    quote?.user?.badges.length ? (
                                                                                                    <div className='ml-2 flex justify-center sm:w-[50px]'>
                                                                                                        {quote?.user?.badges.map(badge => (
                                                                                                            <img
                                                                                                                key={badge?.id}
                                                                                                                src={badge?.imageUrl}
                                                                                                                alt={badge?.name}
                                                                                                                className='img-fluid mr-2 h-[30px]'
                                                                                                                onError={(e) => { e.target.style.display = 'none' }}
                                                                                                            />
                                                                                                        ))}
                                                                                                    </div>
                                                                                                )
                                                                                                    : ''}
                                                                                        </div>
                                                                                        {/* <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            quote?.services &&
                                                                quote?.services.length ? (
                                                                <React.Fragment>
                                                                    {quote?.services.slice(0, 3).map((service, index) => (
                                                                        <span key={service?.id}>
                                                                            <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                                {service?.name}

                                                                                {index < quote?.services.slice(0, 3).length - 1 &&
                                                                                    (<span className='mx-1'>|</span>)}
                                                                                {index == 2 && quote?.services.length > 3 ?
                                                                                    (<span className='mr-1'>...</span>) : ''}
                                                                            </p>
                                                                        </span>
                                                                    ))}
                                                                    {quote?.services?.length > 3 ? (
                                                                        <Tooltip title={getServicesList(quote?.services)}>
                                                                            <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                        </Tooltip>
                                                                    ) : ''}
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )}
                                                    </div> */}
                                                                                        <div className='flex justify-center sm:justify-start'>
                                                                                            {
                                                                                                quote?.user?.services &&
                                                                                                    quote?.user?.services?.length > 0 ? (
                                                                                                    <React.Fragment>
                                                                                                        {
                                                                                                            quote?.user?.services?.filter(service => service?.parentId == null)?.slice(0, 3)?.map((service) => {
                                                                                                                return (
                                                                                                                    <span className='flex gap-1 items-center' key={service?.id}>
                                                                                                                        <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                                                            {service?.name + ','}
                                                                                                                        </p>
                                                                                                                    </span>
                                                                                                                )
                                                                                                            })
                                                                                                        }
                                                                                                        {quote?.user?.services?.length > 3 && <span>...</span>}
                                                                                                        {quote?.user?.services?.length > 3 &&
                                                                                                            (
                                                                                                                <Tooltip title={getServicesList(quote?.user?.services?.filter(service => service?.parentId == null) || [], false)}>
                                                                                                                    <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                                                                </Tooltip>
                                                                                                            )
                                                                                                        }
                                                                                                    </React.Fragment>
                                                                                                ) : (
                                                                                                    <small className='text-xs'>Services not available</small>
                                                                                                )
                                                                                            }
                                                                                        </div>

                                                                                        <div className='flex flex-col gap-1'>
                                                                                            <p className='text-xs text-black text-center md:text-left'>Requested Services:</p>
                                                                                            <div className='flex justify-center sm:justify-start'>
                                                                                                {
                                                                                                    quote?.services &&
                                                                                                        quote?.services.length ? (
                                                                                                        <React.Fragment>
                                                                                                            {
                                                                                                                quote?.services?.slice(0, 3)?.map((service) => {
                                                                                                                    if (service?.name) {
                                                                                                                        return (
                                                                                                                            <span className='flex gap-1 items-center justify-start' key={service?.id}>
                                                                                                                                <p className='text-black text-xs mb-3 w-fit'>
                                                                                                                                    {service?.name + ','}
                                                                                                                                </p>
                                                                                                                            </span>
                                                                                                                        )
                                                                                                                    }
                                                                                                                })
                                                                                                            }
                                                                                                            {quote?.services?.length > 3 && <span>...</span>}
                                                                                                            {quote?.services?.length > 3 &&
                                                                                                                (
                                                                                                                    <Tooltip title={getServicesList(quote?.services, false)}>
                                                                                                                        <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                                                                    </Tooltip>
                                                                                                                )}
                                                                                                        </React.Fragment>
                                                                                                    ) : (
                                                                                                        <small className='text-xs'>Services not available</small>
                                                                                                    )}
                                                                                            </div>
                                                                                        </div>
                                                                                        <p className='text-xs sm:text-left text-center'>{quote?.additionalInfo}</p>
                                                                                    </div>
                                                                                    <div className='flex sm:flex-row flex-col flex-wrap'>
                                                                                        <div className='ratings sm:mr-2 mr-0 mb-2 bg-slate-100 flex rounded-md justify-center items-center p-2'>
                                                                                            <span className='mr-2 font-bold'>
                                                                                                {Math.floor(quote?.user?.averageRating)}/5
                                                                                            </span>

                                                                                            {/* rated stars count */}
                                                                                            {
                                                                                                Array(Math.floor(quote?.user?.averageRating))
                                                                                                    .fill(0).map((el, index) => (
                                                                                                        <FaStar key={index} className='text-primary' />
                                                                                                    ))
                                                                                            }
                                                                                            {
                                                                                                quote?.user?.ratingCount - Math.floor(quote?.user?.ratingCount) != 0 &&
                                                                                                (<FaStarHalf className='text-primary' />)
                                                                                            }

                                                                                            {/* unrated stars count */}
                                                                                            {
                                                                                                Array(5 - Math.floor(quote?.user?.averageRating))
                                                                                                    .fill(0).map((el, index) => (
                                                                                                        <FaStar key={index} className='text-gray-400' />
                                                                                                    ))
                                                                                            }
                                                                                        </div>
                                                                                        {/* <div
                                                                                            className='flex justify-center items-center rounded-md bg-[#02B563] cursor-pointer sm:mr-2 mr-0 mb-2 p-2'
                                                                                            onClick={() => navigate(`/reviews/${quote?.serviceProviderId}`)}
                                                                                        >
                                                                                            <small className='text-xs text-white'>Reviews</small>
                                                                                        </div> */}
                                                                                        <Link to={`/profile/${quote?.user?.id}`}>
                                                                                            <div className='flex justify-center items-center rounded-md bg-[#3879f0] cursor-pointer sm:mr-2 mr-0 mb-2 p-2'>
                                                                                                <FaUser className='text-white bg-[#6698f3] rounded-full p-[5px] text-2xl' />
                                                                                                <small className='text-xs text-white ml-2'>View Profile</small>
                                                                                            </div>
                                                                                        </Link>
                                                                                        <div className='sm:mr-2 mr-0 mb-2 p-2 bg-[#feedbf] rounded-md'>
                                                                                            <ChatModal selectedChatMemberData={quote?.user} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='flex sm:flex-row flex-col justify-around'>
                                                                                {/* <div className='flex flex-col justify-start sm:border-r sm:border-l sm:border-slate-100 sm:px-4'>
                                                                                    {
                                                                                        quote?.user &&
                                                                                        quote?.user?.userDetail &&
                                                                                        quote?.user?.userDetail?.benefits &&
                                                                                        JSON.parse(quote?.user?.userDetail?.benefits).map((benefit, index) => (
                                                                                            <div className='flex' key={index}>
                                                                                                <div className='w-[20px]'>
                                                                                                    <FaCheck className='text-primary' />
                                                                                                </div>
                                                                                                <small className='sm:text-xs text-sm font-semibold mb-2'>
                                                                                                    {benefit}
                                                                                                </small>
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </div> */}
                                                                                <div className='flex flex-col items-center sm:ml-4'>
                                                                                    <small className='inline-block font-semibold sm:mb-4 mb-2 sm:text-xs text-lg text-[#FF1D6A]'>
                                                                                        {
                                                                                            `(${Math.round(quote?.distance) > 0 ?
                                                                                                quote?.distance.toFixed(2) :
                                                                                                0
                                                                                            } Miles Away)`
                                                                                        }
                                                                                    </small>
                                                                                    <div className='mb-2 w-full flex flex-col items-center'>
                                                                                        <h2 className='sm:heading-2 heading-1 font-bold mb-4'>£{quote?.price}</h2>
                                                                                        {<div className='flex gap-2'>
                                                                                            <div
                                                                                                onClick={() => handleQuoteAcceptClick(quote)}
                                                                                                className='w-full sm:py-3 py-4 p-3 sm:text-xs text-lg rounded-lg bg-[#02B563] text-white text-center cursor-pointer
                                                    '
                                                                                            >
                                                                                                Accept
                                                                                            </div>
                                                                                            <div
                                                                                                onClick={() => handleDecision(quote?.id, 'Reject')}
                                                                                                className='w-full sm:py-3 py-4 p-3 sm:text-xs text-lg rounded-lg bg-[#FF1D6A] text-white text-center cursor-pointer
                                                    '
                                                                                            >
                                                                                                Reject
                                                                                            </div>
                                                                                        </div>}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Card>
                                                                )
                                                            }) : (
                                                                <div className='flex justify-center'>
                                                                    <h6 className='heading-6 font-bold'>No Quotes Received</h6>
                                                                </div>
                                                            )
                                                    }
                                                </Col>



                                            )}

                                        {/* Payment Selection for Quote Acceptance */}
                                        {bookingConfirm && selectedQuoteForAccept && (
                                            <div className='mt-4'>
                                                <PaymentDetails
                                                    data={selectedQuoteForAccept}
                                                    onSuccess={handleQuotePaymentConfirm}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : ''}

                                {bookingDetails?.reasonOfRejection && getBookingStatus(bookingDetails?.status) == 'rejected' ? (
                                    <div>
                                        <h6 className='heading-6 font-bold text-sm mb-2'>Rejection Reason</h6>
                                        <small className='text-xs font-md'>{bookingDetails?.reasonOfRejection}</small>
                                    </div>
                                ) : ''}

                                {/* case: responded */}
                                {
                                    !OtherUserBookingDetails && bookingConfirm &&
                                        (getBookingStatus(bookingDetails?.status) == 'responded' || getBookingStatus(bookingDetails?.status) == 'admin assigned') ?
                                        (
                                            <React.Fragment>
                                                <div className='bg-slate-100'>
                                                    <PaymentDetails
                                                        data={bookingDetails?.quotes[0]}
                                                        onSuccess={handlePaymentConfirm}
                                                    />
                                                </div>
                                            </React.Fragment>
                                        ) : (<React.Fragment>
                                            <div className='bg-slate-100'>




                                                {OtherUserBookingDetails?.quotes && OtherUserBookingDetails?.quotes.length && OtherUserBookingDetails?.quotes[0]?.date ? (
                                                    <div className="flex items-center sm:mb-0 mb-2 w-full sm:w-1/6">
                                                        <div className="w-[30px] mr-2">
                                                            <FaCalendarAlt className="bg-[#fa3434] text-xl text-white p-[3px] rounded-full" />
                                                        </div>
                                                        <small className="text-xs font-md">
                                                            {getFormattedDateTime(
                                                                `${OtherUserBookingDetails?.quotes[0]?.date}T${OtherUserBookingDetails?.quotes[0]?.time}`,
                                                                "DD-MM-YYYY HH:mm",
                                                            )}
                                                        </small>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>

                                            {/* <hr className='border-dashed border-1 border-gray-200 mb-4' /> */}

                                            {/* <div className='mb-4'>
                                    <h6 className='heading-6 font-bold text-sm mb-4'>Services Requested:</h6>
                                    <div className='flex sm:flex-row flex-col'>
                                        {
                                            OtherUserBookingDetails?.services &&
                                                OtherUserBookingDetails.services.length ? (
                                                <React.Fragment>
                                                    {
                                                        OtherUserBookingDetails?.services.slice(0, 3).map((service, index) => (
                                                            <div className='flex items-center mr-2 mb-2' key={index}>
                                                                <div className='w-[20px]'>
                                                                    <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                                                </div>
                                                                <small className='font-md text-xs'>{service?.name}</small>
                                                            </div>
                                                        ))
                                                    }
                                                    {OtherUserBookingDetails?.services?.length > 3 ? (
                                                        <Tooltip title={getServicesList(OtherUserBookingDetails?.services)}>
                                                            <p className='text-xs sm:ml-2 mt-[2px] cursor-pointer'>show all</p>
                                                        </Tooltip>
                                                    ) : ''}
                                                </React.Fragment>
                                            ) : (
                                                <small className='text-xs'>Services not available</small>
                                            )
                                        }
                                    </div>
                                </div> */}

                                            <hr className="border-dashed border-1 border-gray-200 mb-4" />

                                            {/* {OtherUserBookingDetails?.selectedCategories && (
                  <div className="mt-4">
                    {OtherUserBookingDetails?.selectedCategories?.length > 0 ? (
                      getAllServices(OtherUserBookingDetails?.selectedCategories)
                    ) : (
                      <small className="text-xs">Services not available</small>
                    )}
                  </div>
                )} */}

                                            <div className='mt-4 mb-5'>
                                                {OtherUserBookingDetails?.services?.length > 0 ?
                                                    getLastLayerServices(OtherUserBookingDetails?.services)
                                                    :
                                                    <small className='text-xs'>Services not available</small>
                                                }
                                            </div>

                                            {OtherUserBookingDetails && OtherUserBookingDetails?.details && (
                                                <div className="mb-4">
                                                    <h6 className="heading-6 font-bold text-sm mb-2">Additional Info/Note</h6>
                                                    <small className="text-xs font-md">{OtherUserBookingDetails?.details}</small>
                                                </div>
                                            )}

                                            {!quoteConfirm &&
                                                getBookingStatus(OtherUserBookingDetails?.status) == "responded" &&
                                                OtherUserBookingDetails?.quotes.length && (
                                                    <div className="bg-blue-500 p-2 w-full mb-4 rounded-md">
                                                        <small className="text-white">
                                                            {`${OtherUserBookingDetails?.user?.fullName} has
                                                updated your quote No. ${OtherUserBookingDetails?.id} quoted price
                                                £${OtherUserBookingDetails?.quotes[0].price} 
                                                ${OtherUserBookingDetails?.quotes[0].vatIncluded ? "(Prices include VAT where applicable)." : ""}  
                                            `}
                                                        </small>
                                                    </div>
                                                )}

                                            {/* case: pending */}
                                            {/* su accepts/rejects quote sent by sp */}
                                            {!quoteConfirm &&
                                                getBookingStatus(OtherUserBookingDetails?.status) == "responded" &&
                                                OtherUserBookingDetails?.quotes &&
                                                OtherUserBookingDetails?.quotes.length ? (
                                                <div className="flex mb-4">
                                                    {quoteDecisions.map((decision) => (
                                                        <div
                                                            key={decision?.id}
                                                            // onClick={() => handleQuoteBySP(decision?.id)}
                                                            className={`sm:w-fit w-full mr-2 text-xs px-6 py-3 text-white rounded-md cursor-pointer text-center`}
                                                            style={{
                                                                backgroundColor: decision?.color,
                                                            }}
                                                        >
                                                            {decision?.label}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                            {OtherUserBookingDetails?.reasonOfRejection && getBookingStatus(OtherUserBookingDetails?.status) == "rejected" && (
                                                <div>
                                                    <h6 className="heading-6 font-bold text-sm mb-2">Rejection Reason</h6>
                                                    <small className="text-xs font-md">{OtherUserBookingDetails?.reasonOfRejection}</small>
                                                </div>
                                            )}

                                            {OtherUserBookingDetails?.booking?.userId === loggedInUser?.id &&
                                                getBookingStatus(OtherUserBookingDetails?.status) === "pending" && (
                                                    <React.Fragment>
                                                        {/* {OtherUserBookingDetails?.serviceProviderId && (
                        <div className="mb-4">
                          <h6 className="heading-6 font-bold text-sm">Quote Location:</h6>
                          <div className="bg-slate-100 flex justify-between items-center rounded-md w-full p-4">
                            <small className="text-xs">{userLocation?.address}</small>
                            <div className="w-[20px] cursor-pointer">
                              <MdMyLocation className="text-primary" onClick={() => setShowLocationPicker(true)} />
                            </div>
                          </div>
                        </div>
                      )} */}
                                                        <div className="bg-slate-100">
                                                            <PaymentDetails data={OtherUserBookingDetails} onSuccess={handlePaymentConfirm} />
                                                        </div>
                                                    </React.Fragment>
                                                )}


                                            <Modal.Basic
                                                open={showSPQuoteSuccessAlert}
                                                onCancel={() => setShowSPQuoteSuccessAlert(false)}
                                                width={300}
                                                maskClosable={false}
                                            >
                                                <Alert
                                                    onSuccess={() => setShowSPQuoteSuccessAlert(false)}
                                                    onCancel={() => setShowSPQuoteSuccessAlert(false)}
                                                />
                                            </Modal.Basic>

                                            {showLocationPicker ? (
                                                <div className="w-[300px]">
                                                    <LocationPicker
                                                        addressPicker={handleSelectedLocation}
                                                        hideInput
                                                        modal={showLocationPicker}
                                                        onClose={() => setShowLocationPicker(false)}
                                                    />
                                                </div>
                                            ) : (
                                                ""
                                            )}





                                        </React.Fragment>)
                                }
                            </div>
                        </Card>
                    ) : (
                        <div className='w-full flex flex-col items-center'>
                            <h5 className='heading-5 font-bold'>Booking not found</h5>
                        </div>
                    )}

                    <Modal.Basic open={showModal} onCancel={() => setShowModal(false)} width={300} maskClosable={false}>
                        {modalType == 'bookingSuccess' ? (
                            <Alert onSuccess={() => setShowModal(false)} onCancel={() => setShowModal(false)} />
                        ) : modalType == 'rateBooking' ? (
                            <ReviewInput
                                data={bookingDetails?.serviceProvider}
                                response={handleUserReview}
                            />
                        ) : ''}
                    </Modal.Basic>

                    {showLocationPicker ? (
                        <div className='w-[300px]'>
                            <LocationPicker
                                addressPicker={handleSelectedLocation}
                                hideInput
                                modal={showLocationPicker}
                                onClose={() => setShowLocationPicker(false)}
                            />
                        </div>
                    ) : ''}

                    <Modal.Basic
                        open={prompt}
                        closeable={false}
                        width={300}
                        maskClosable={false}
                    >
                        <Prompt.Basic
                            type={
                                promptData?.type == 'locationInfo' ? 'ok' : null
                            }
                            message={promptData?.msg}
                            onChange={handlePromptResponse}
                            closeModal={() => setPrompt(false)}
                        />
                    </Modal.Basic>
                </Col>
                {
                    showBookingForm && (
                        <Col lg={7} md={12} sm={18} xs={24} className='px-2 pt-6 mx-auto'>
                            <div className='bg-black rounded-md p-4 w-full'>
                                <h6 className='heading-6 text-md text-white font-bold mb-1'>Book Service</h6>
                                <small className='text-xs text-white mb-4 inline-block'>Vehicle Registration</small>
                                <BookingForm
                                    spServicesData={formattedData.initialData}
                                    selectedFiltersValue={formattedData.selectedData}
                                    editData={rebookData}
                                    bookingFormDataOrStatusHandler={bookingFormDataOrStatusHandler}
                                    isServicesFilled={true}
                                />
                            </div>
                        </Col>
                    )
                }

                {
                    disputeModal ? (
                        <DisputeForm
                            isModalOpen={disputeModal}
                            setIsModalOpen={setDisputeModal}
                            formResponseHandler={disputeFormHandler}
                            bookingId={bookingId}
                            disputedAgainstId={disputedAgainstId}
                            disputedEmail={loggedInUser?.email}
                        />
                    )
                        : ''
                }
            </Row>

            {/* Payment Modal for Quote Acceptance */}
            {
                bookingConfirm && selectedQuoteForAccept && (
                    <Modal.Basic
                        className="!m-8"
                        open={bookingConfirm}
                        onCancel={() => {
                            setBookingConfirm(false)
                            setSelectedQuoteForAccept(null)
                        }}
                        width={600}

                        maskClosable={false}
                    >
                        <PaymentDetails
                            data={selectedQuoteForAccept}
                            onSuccess={handleQuotePaymentConfirm}
                        />
                    </Modal.Basic>
                )
            }
        </React.Fragment >
    )
}

export default BookingDetails



const Alert = React.memo(() => {
    const navigate = useNavigate()
    return (
        <Card bordered={false} className='rounded-md'>
            <div className='flex flex-col items-center'>
                <img src={successCheck} alt='check-success' className='img-fluid w-[200px]' />
                <h3 className='heading-3 font-bold'>Thank You</h3>
                <p className='mb-2'>Your message has been received and we would be contacting you shortly</p>
                <div className="flex justify-end w-full">
                    <Button.Basic
                        onClick={() => navigate('/booking/my-bookings')}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='Go to My Bookings'
                        className='btn-primary w-full'
                    />
                </div>
            </div>
        </Card>
    )
});


// for booking cases -- not for amendment
const PaymentDetails = ({ data, onSuccess }) => {
    console.log(data, "mydataaaaaaaaaaa");


    const [selectedCreditCardProvider, setSelectedCreditCardProvider] = useState('');
    const { loading, cards, error } = useSelector(state => state?.payments);
    const [fetchCardsTrigger, setFetchCardTrigger] = useState(false);

    const dispatch = useDispatch();


    // useEffect(() => {
    //     const handleVisibilityChange = () => {
    //         if (document.visibilityState === 'visible') {
    //             if (cards?.length == 0) {
    //                 dispatch(fetchCards())
    //             }
    //         }
    //     };
    //     document.addEventListener('visibilitychange', handleVisibilityChange);
    //     return () => {
    //         document.removeEventListener('visibilitychange', handleVisibilityChange);
    //     };
    // }, [cards]);


    // const form = {
    //     name: 'addCreditCardForm',
    //     formFields: [
    //         {
    //             name: 'cardHolderName',
    //             label: { value: 'Card Holder Name:', classes: '' },
    //             type: 'text',
    //             placeholder: 'Victor Niculici',
    //             width: { md: 6, sm: 6, xs: 24 },
    //             component: null,
    //             classes: '',
    //             icon: null
    //         },
    //         {
    //             name: 'cardNumber',
    //             label: { value: 'Card Number', classes: '' },
    //             type: 'text',
    //             placeholder: '4533 5555 6666 7777',
    //             width: { md: 6, sm: 6, xs: 24 },
    //             component: null,
    //             classes: '',
    //             icon: null,
    //         },
    //         {
    //             name: 'cardExpiry',
    //             label: { value: 'Expiry Date:', classes: '' },
    //             type: 'datepicker',
    //             format: 'MM/YYYY',
    //             placeholder: '10 June, 2024',
    //             width: { md: 6, sm: 6, xs: 24 },
    //             component: null,
    //             classes: 'h-[47px] w-full',
    //             icon: null
    //         },
    //         {
    //             name: 'cardCVV',
    //             label: { value: 'CVV:', classes: '' },
    //             type: 'password',
    //             placeholder: '',
    //             width: { md: 6, sm: 6, xs: 24 },
    //             component: null,
    //             classes: '',
    //             icon: null
    //         },
    //     ],
    //     formValidation: {
    //         cardHolderName: Yup.string()
    //             .required('Card holder name is required')
    //             .min(3, 'Card holder name must be at least 3 characters')
    //             .matches(/^[a-zA-Z\s]+$/, 'Card holder name should only contain letters and spaces'),

    //         cardNumber: Yup.string()
    //             .required('Card number is required')
    //             .matches(/^[0-9]{16}$/, 'Card number must be exactly 16 digits'),

    //         cardCVV: Yup.string()
    //             .required('CVV is required')
    //             .matches(/^[0-9]{3}$/, 'CVV must be exactly 3 digits'),
    //     }
    // }

    useEffect(() => {
        const visibilityChangeHandler = () => {
            if (document.visibilityState == 'visible' && fetchCardsTrigger) {
                dispatch(fetchCards());
            }
        }
        document.addEventListener('visibilitychange', visibilityChangeHandler)
        return () => {
            document.removeEventListener('visibilitychange', visibilityChangeHandler);
        }
    }, [fetchCardsTrigger])


    const handleCreditCardProviderSelection = (e) => {
        setSelectedCreditCardProvider(e.target.value)
    }

    const handleSubmit = (values) => {
        if (!selectedCreditCardProvider) {
            dispatch(setError('Kindly select your card to proceed'))
            return
        }
        else {
            onSuccess(true, selectedCreditCardProvider)
        }
    };


    // stripe card add call.
    const cardAddMutation = useMutation(async () => {
        let res = await axiosInstance.post('/stripe/add-card', {});
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                window.open(res?.data?.data?.cardCheckoutSession, '_blank')
                setFetchCardTrigger(true)
                dispatch(setAppLoading(false))
            },
            onError: (error) => {
                dispatch(setAppLoading(false))
                dispatch(setError(error.response?.data?.message || 'An error occured'))
            }
        }
    )

    const cardAttachHandler = () => {
        dispatch(setAppLoading(true))
        cardAddMutation.mutate()
    }

    // const submitForm = () => {
    //     document.querySelector('form#addCreditCardForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    // }

    return (
        <div className='p-4 w-full flex flex-col'>
            <div>
                <h6 className='heading-6 font-semibold text-xs'>Quoted Price:</h6>
                <h2 className='heading-2 font-bold'>£{data?.price}</h2>
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='mb-4'>
                <h6 className='heading-6 font-semibold sm:text-xs'>Services Requested:</h6>
                <div className='flex sm:flex-row flex-col'>
                    {
                        data?.services &&
                            data?.services.length > 0 ?
                            data?.services.slice(0, 3).map((service, index) => (
                                <span key={'ser5' + index} className='inline-block mb-2'>
                                    <p className='text-gray-500 font-bold' >
                                        {service?.name}

                                        {index < data?.services.slice(0, 3).length - 1 &&
                                            (<span className='mx-1'>|</span>)}
                                        {index == 2 && data?.services.length > 3 ?
                                            (<span className='mr-1'>...</span>) : ''}
                                    </p>
                                </span>
                            )) : (
                                <small className='text-xs'>Not available</small>
                            )
                    }
                    {data?.services?.length > 3 ? (
                        <Tooltip title={getServicesList(data?.services)}>
                            <p className='text-xs sm:ml-2 mt-[2px] cursor-pointer'>show all</p>
                        </Tooltip>
                    ) : ''}
                </div>

                {/* <div className='mt-4'>
                    {servicesLength > 0 ?
                        getLastLayerServices(data?.serviceProvider?.services)
                        :
                        <small className='text-xs'>Services not available</small>
                    }
                </div> */}
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='mb-4'>
                <h6 className='heading-6 font-semibold text-xs'>Details of Service:</h6>
                <p className='text-xs font-semibold'>{data?.details}</p>
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='mb-4'>
                <h6 className='heading-6 font-semibold text-xs'>Appointment - Date & Time:</h6>
                <div className='flex items-center'>
                    <FaCalendarAlt className='bg-[#fa3434] text-xl text-white p-[3px] rounded-full mr-2' />
                    <p className='text-xs font-semibold'>
                        {getFormattedDateTime(`${data?.date}T${data?.time}`, 'DD-MM-YYYY HH:mm')}
                    </p>
                </div>
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='bg-[#02b463] p-2 sm:w-3/5 w-full mb-4 rounded-sm'>
                <small className='text-white text-xs'>Payments will be disbursed only when the job is completed and closed.</small>
            </div>

            <div className='w-full mb-6 flex gap-2 items-center flex-wrap'>
                {
                    loading ? (
                        <Spin indicator={<LoadingOutlined loading />} size="default" />
                    )
                        :
                        cards && cards?.length > 0 && (

                            <>
                                <Radio.Group className='flex sm:flex-row flex-col gap-2 flex-wrap' onChange={handleCreditCardProviderSelection} value={selectedCreditCardProvider}>
                                    {cards?.map((card) => (
                                        <div
                                            className={`bg-white p-2 flex justify-between w-fit mb-2 gap-5`}
                                            key={'card' + card?.id}
                                        >
                                            <div className='flex flex-nowrap px-4 gap-4'>
                                                <div className='flex items-center'>
                                                    <img src={cardImageSelector(card?.brand)} alt='credit card provider icon' className='img-fluid w-[50px]' />
                                                </div>
                                                <div className='flex flex-col gap-0'>
                                                    <h6 className='heading-6 font-bold mb-1'>
                                                        {card?.brand}
                                                    </h6>
                                                    <p className='text-xs flex flex-row gap-1'>**** **** **** <span>{card?.last4}</span></p>
                                                </div>
                                            </div>
                                            <Radio value={card?.id} className=''></Radio>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </>
                        )
                }

                {
                    !loading &&
                    <div className='w-full flex flex-col gap-2'>
                        {
                            cards?.length == 0 && <p>No cards attached.</p>
                        }
                        <Button.Basic
                            onClick={cardAttachHandler}
                            disabled={false}
                            icon={null}
                            loading={false}
                            type="primary"
                            size='medium'
                            text='add Card'
                            className='btn-primary bg-[#02B463] sm:w-fit w-full'
                        />
                    </div>
                }

            </div>

            <div className='flex flex-col'>
                {/* <div className='mb-4'>
                    <h6 className='heading-6 font-bold mb-1'>Add New Card:</h6>
                    <small className='text-xs'>Enter your credit card details.</small>
                </div> */}

                {/* <DynamicForm id='addCreditCardForm' form={form} onSubmit={handleSubmit} /> */}
                {
                    cards && cards?.length > 0 &&
                    <div className="w-full">
                        <Button.Basic
                            onClick={handleSubmit}
                            disabled={false}
                            icon={null}
                            loading={false}
                            type="primary"
                            size='medium'
                            text='Confirm Payment'
                            className='btn-primary sm:w-fit w-full'
                        />
                    </div>
                }

            </div>
        </div >
    )
}

// amendment payment Details case
const AmendmentDetails = ({ data, onSuccess }) => {

    const [selectedCreditCardProvider, setSelectedCreditCardProvider] = useState('');
    const { loading, cards, error } = useSelector(state => state?.payments);
    const dispatch = useDispatch();

    const handleCreditCardProviderSelection = (e) => {
        setSelectedCreditCardProvider(e.target.value)
    }

    const handleSubmit = (values) => {
        if (!selectedCreditCardProvider) {
            dispatch(setError('Kindly select your card to proceed'))
            return
        }
        else {
            onSuccess('accept', selectedCreditCardProvider)
        }
    };

    return (
        <div className='p-4 w-full flex flex-col'>
            <div>
                <h6 className='heading-6 font-semibold text-xs'>Quoted Price:</h6>
                <h2 className='heading-2 font-bold'>£{data?.bookingAmendment?.price}</h2>
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            {/* <div className='mb-4'>
                <h6 className='heading-6 font-semibold sm:text-xs'>Services Requested:</h6>
                <div className='flex sm:flex-row flex-col'>
                    {
                        data?.serviceProvider?.services &&
                            data?.serviceProvider?.services.length ?
                            data?.serviceProvider?.services.slice(0, 3).map((service, index) => (
                                <span key={index} className='inline-block mb-2'>
                                    <p className='text-gray-500 font-bold' >
                                        {service?.name}

                                        {index < data?.serviceProvider?.services.slice(0, 3).length - 1 &&
                                            (<span className='mx-1'>|</span>)}
                                        {index == 2 && data?.serviceProvider?.services.length > 3 ?
                                            (<span className='mr-1'>...</span>) : ''}
                                    </p>
                                </span>
                            )) : (
                                <small className='text-xs'>Not available</small>
                            )
                    }
                    {data?.serviceProvider?.services?.length > 3 ? (
                        <Tooltip title={getServicesList(data?.serviceProvider?.services)}>
                            <p className='text-xs sm:ml-2 mt-[2px] cursor-pointer'>show all</p>
                        </Tooltip>
                    ) : ''}
                </div>
            </div> */}

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='mb-4'>
                <h6 className='heading-6 font-semibold text-xs'>Details of Service:</h6>
                <p className='text-xs font-semibold'>{data?.bookingAmendment?.note}</p>
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='mb-4'>
                <h6 className='heading-6 font-semibold text-xs'>Appointment - Date & Time:</h6>
                <div className='flex items-center'>
                    <FaCalendarAlt className='bg-[#fa3434] text-xl text-white p-[3px] rounded-full mr-2' />
                    <p className='text-xs font-semibold'>
                        {
                            data?.startTime ?
                                getFormattedDateTime(`${data?.bookingDate}T${data?.startTime}`, 'DD-MM-YYYY HH:mm')
                                :
                                data?.bookingDate
                        }
                    </p>
                </div>
            </div>

            <hr className='border-dashed border-1 border-gray-200 mb-4' />

            <div className='bg-[#02b463] p-2 sm:w-3/5 w-full mb-4 rounded-sm'>
                <small className='text-white text-xs'>Payments will be disbursed only when the job is completed and closed.</small>
            </div>

            <div className='w-full mb-6 flex gap-2 items-center flex-wrap'>
                {
                    loading ?
                        <Spin indicator={<LoadingOutlined loading />} size="default" />
                        :
                        cards && cards?.length > 0 ?
                            <Radio.Group className='flex sm:flex-row flex-col gap-2 flex-wrap' onChange={handleCreditCardProviderSelection} value={selectedCreditCardProvider}>
                                {cards?.map((card) => (
                                    <div
                                        className={`bg-white p-2 flex justify-between w-fit mb-2 gap-5`}
                                        key={card?.id}
                                    >
                                        <div className='flex flex-nowrap px-4 gap-4'>
                                            <div className='flex items-center'>
                                                <img src={cardImageSelector(card?.brand)} alt='credit card provider icon' className='img-fluid w-[50px]' />
                                            </div>
                                            <div className='flex flex-col gap-0'>
                                                <h6 className='heading-6 font-bold mb-1'>
                                                    {card?.brand}
                                                </h6>
                                                <p className='text-xs flex flex-row gap-1'>**** **** **** <span>{card?.last4}</span></p>
                                            </div>
                                        </div>
                                        <Radio value={card?.id} className=''></Radio>
                                    </div>
                                ))}
                            </Radio.Group>
                            :
                            <p>No cards attached.</p>
                }
            </div>

            <div className='flex flex-col'>
                <div className="w-full">
                    <Button.Basic
                        onClick={handleSubmit}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='Confirm Payment'
                        className='btn-primary sm:w-fit w-full'
                    />
                </div>
            </div>
        </div>
    )

}
